import React from "react";

const AnimStyles = () => (<style>{`
@keyframes fadeSlideIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes scaleIn { from { opacity: 0; transform: scale(0.92); } to { opacity: 1; transform: scale(1); } }
@keyframes modalBounce { 0% { opacity: 0; transform: scale(0.85) translateY(10px); } 60% { opacity: 1; transform: scale(1.02) translateY(-2px); } 100% { opacity: 1; transform: scale(1) translateY(0); } }
@keyframes slideDown { from { opacity: 0; transform: translateY(-16px); } to { opacity: 1; transform: translateY(0); } }
@keyframes slideInRight { from { opacity: 0; transform: translateX(20px); } to { opacity: 1; transform: translateX(0); } }
@keyframes countPulse { 0% { transform: scale(1); } 50% { transform: scale(1.08); } 100% { transform: scale(1); } }
@keyframes bellShake { 0%,100% { transform: rotate(0); } 15% { transform: rotate(12deg); } 30% { transform: rotate(-10deg); } 45% { transform: rotate(8deg); } 60% { transform: rotate(-5deg); } 75% { transform: rotate(3deg); } }
@keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
@keyframes cardStagger { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
.anim-page { animation: fadeSlideIn 0.35s ease-out both; }
.anim-card { animation: fadeSlideIn 0.4s ease-out both; }
.anim-modal-overlay { animation: fadeIn 0.2s ease-out both; }
.anim-modal-content { animation: modalBounce 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both; }
.anim-toast { animation: slideDown 0.3s ease-out both; }
.anim-slide-right { animation: slideInRight 0.3s ease-out both; }
.anim-stat { animation: fadeSlideIn 0.4s ease-out both; }
.anim-row { animation: fadeIn 0.25s ease-out both; }
.anim-bell { animation: bellShake 0.6s ease-in-out; }
.btn-hover { transition: all 0.18s ease; }
.btn-hover:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0,0,0,0.12); }
.btn-hover:active { transform: translateY(0) scale(0.97); }
.card-hover { transition: all 0.2s ease; }
.card-hover:hover { transform: translateY(-3px); box-shadow: 0 8px 24px rgba(0,0,0,0.08); }
.row-hover { transition: background 0.15s ease; }
.row-hover:hover { background: rgba(0,0,0,0.02) !important; }
.nav-item { transition: all 0.18s ease; }
.nav-item:hover { transform: translateX(3px); }
@media (orientation: landscape) and (max-height: 500px) {
  h2 { font-size: 18px !important; margin-bottom: 8px !important; }
  h2 + p { display: none !important; }
  .anim-page > div > div:first-child { margin-bottom: 8px !important; }
  .anim-page { padding: 8px !important; }
  table th, table td { padding: 4px 8px !important; font-size: 11px !important; }
}
`}</style>);

export default AnimStyles;
